import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { family } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";

export default function Question2Family() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>
            {t("How would you describe your relationship with your family?")}
          </h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("Nothing to report")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(family(value))}
          rightElement={<p>{t("How much time do you have?")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
